
export default {
	data(){
		return {
			isloginwin:"", //是否登录
			oldorder:"",
			orderlist:[], //历史订单列表
			replaceList:{
				bheight: [
					{real: '0.4',word: '0.4mm'},
					{real: '0.6',word: '0.6mm'},
					{real: '0.8',word: '0.8mm'},
					{real: '1',word: '1.0mm'},
					{real: '1.2',word: '1.2mm'},
					{real: '1.6',word: '1.6mm'},
					{real: '1.7',word: '1.7mm'},
					{real: '1.8',word: '1.8mm'},
					{real: '1.9',word: '1.9mm'},
					{real: '2',word: '2.0mm'},
					{real: '2.1',word: '2.1mm'},
					{real: '2.2',word: '2.2mm'},
					{real: '2.3',word: '2.3mm'},
					{real: '2.4',word: '2.4mm'},
					{real: '2.5',word: '2.5mm'},
					{real: '2.6',word: '2.6mm'},
					{real: '2.7',word: '2.7mm'},
					{real: '2.8',word: '2.8mm'},
					{real: '2.9',word: '2.9mm'},
					{real: '3',word: '3.0mm'},
					{real: '3.2',word: '3.2mm'}],
				rogersbheight1:[
					{real: '0.101',word: '4mil (0.101mm)'},
					{real: '0.168',word: '6.6mil (0.168mm)'},
					{real: '0.203',word: '8mil (0.203mm)'},
					{real: '0.254',word: '10mil (0.254mm)'},
					{real: '0.305',word: '12mil (0.305mm)'},
					{real: '0.338',word: '13.3mil (0.338mm)'},
					{real: '0.406',word: '16mil (0.406mm)'},
					{real: '0.422',word: '16.6mil (0.422mm)'},
					{real: '0.508',word: '20mil (0.508mm)'},
					{real: '0.762',word: '30mil (0.762mm)'},
					{real: '0.813',word: '32mil (0.813mm)'},
					{real: '1.524',word: '60mil (1.524mm)'}
				],
				rogersbheight2:[
					{real: '0.2',word: '0.2mm'},
					{real: '0.3',word: '0.3mm'},
					{real: '0.4',word: '0.4mm'},
					{real: '0.6',word: '0.6mm'},
					{real: '0.7',word: '0.7mm'},
					{real: '0.8',word: '0.8mm'},
					{real: '0.9',word: '0.9mm'},
					{real: '1',word: '1.0mm'},
					{real: '1.1',word: '1.1mm'},
					{real: '1.2',word: '1.2mm'},
					{real: '1.3',word: '1.3mm'},
					{real: '1.4',word: '1.4mm'},
					{real: '1.5',word: '1.5mm'},
					{real: '1.6',word: '1.6mm'},
					{real: '1.7',word: '1.7mm'},
					{real: '1.8',word: '1.8mm'},
					{real: '1.9',word: '1.9mm'},
					{real: '2',word: '2.0mm'},
					{real: '2.1',word: '2.1mm'},
					{real: '2.2',word: '2.2mm'},
					{real: '2.3',word: '2.3mm'},
					{real: '2.4',word: '2.4mm'},
					{real: '2.5',word: '2.5mm'},
					{real: '2.6',word: '2.6mm'},
					{real: '2.7',word: '2.7mm'},
					{real: '2.8',word: '2.8mm'},
					{real: '2.9',word: '2.9mm'},
					{real: '3',word: '3.0mm'},
					{real: '3.1',word: '3.1mm'},
					{real: '3.2',word: '3.2mm'}
				]
			},
			//手动选择的参数，用于记录历史选值 在change方法中赋值
			manualParams:{},
			//多选参数记录
			//multiParams:{}
		}
	},
	mounted(){
		this.list.bheight = this.replaceList.bheight;		
		//历史订单赋值需要执行 this.countPersonality(this.personality); 				this.countSpecialprocess(this.specialprocess);
		// this.noAcceptParams()
	},
	computed:{	
		pressingShow(){
			let rst = this.params.blayer >= 4 && this.params.blayer <= 20;
			this.$store.commit("setQuoteParams",{key:"pcb_hideparams.pressing",value:rst});
			return rst;
		},	
		TGshow(){
			const rst = this.params.plate_type === 'Fr-4' || this.isRogers;
			this.$store.commit("setQuoteParams",{key:"pcb_hideparams.board_tg",value:rst});
			return rst;
		},
		thermalcShow(){
			let rst = this.params.plate_type == 'Copper' || this.params.plate_type == 'Aluminum';
				// this.$store.commit("setQuoteParams",{key:"pcb_hideparams.thermalc",value:rst});
			return rst;
		},
		rogersShow(){
			let rst = this.params.plate_type == 'Rogers';
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.rogers",value:rst});
			return rst;
		},
		insidecopperShow(){
			let rst = this.params.blayer > 2 ;
			if (rst && !this.params.insidecopper) {
				this.params.insidecopper = 0.5
			}
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.insidecopper",value:rst});
			return rst;
		},
		blindShow(){
			let rst = this.blind == 1 //this.$tools.inArray('blind',this.specialprocess);
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.blind",value:rst});
			return rst;
		},
		// via_in_padShow(){
		// 	let rst = this.$tools.inArray('via_in_pad',this.specialprocess);
		// 		this.$store.commit("setQuoteParams",{key:"pcb_hideparams.via_in_pad",value:rst});
		// 	return rst;
		// },
		tow_reportShow(){
			let rst = this.$tools.inArray('shipment_report',this.personality),
				rst2 = this.$tools.inArray('slice_report',this.personality),
				rst3 = this.$tools.inArray('film_report',this.personality);
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.shipment_report",value:rst});
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.slice_report",value:rst2});
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.film_report",value:rst3});
				return rst || rst2 ;
		},
		period_formatShow(){
			let rst = this.$tools.inArray('has_period',this.personality);
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.period_format",value:rst});
			return rst;
		},
		pcscountShow (){
			let rst = this.pcscount && this.params.units != 1;
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.pcscount",value:rst});
			return rst;
		},
		cjhShow(){
			let rst = this.params.spray == 'ENIG' || this.params.spray == 'ENIG + OSP';
			if(rst && !this.params.cjh) {
				this.params.cjh = 1
			}
				this.$store.commit("setQuoteParams",{key:"pcb_hideparams.cjh",value:rst});
			return rst;
		},
		// 不是Fr-4板材
		notIsFr4(){
			return this.params.plate_type !== 'Fr-4'
		},
		testpointSum() {
			return Number(this.params.testpoint) * Number(this.params.bcount) || 0
		},
		isFpc() {
			return this.params.plate_type === 'Flex board'
		},
		djhShow(){
			let rst = this.params.spray == 'Electroplated Gold';
			if(rst && !this.params.electrogilding_thickness) {
				this.params.electrogilding_thickness = '1'
			}
				// this.$store.commit("setQuoteParams",{key:"pcb_hideparams.cjh",value:rst});
			return rst;
		},
		fpcInsideCopperShow() {
			const flag = (this.isFpc && this.params.blayer > 2) || this.isRfpc && this.params.fpc_blayer > 2
			if (flag) {
				!this.isClick.fpc_insidecopper && (this.params.fpc_insidecopper = '1/3')
			} else {
				this.params.fpc_insidecopper = ''
			}
			return flag
		},
		fpcMoldFormingShow() {
			return( this.isFpc || this.isRfpc) && this.fpc_forming_method != 'Laser Forming'
		},
		isRfpc() {
			return this.params.plate_type === 'Rigid-Flex board'
		},
		isFr4() {
			return this.params.plate_type === 'Fr-4'
		},
		isAluminum() {
			return this.params.plate_type === 'Aluminum'
		},
		isCopper() {
			return this.params.plate_type === 'Copper'
		},
		isRogers() {
			return this.params.plate_type === 'Rogers'
		}
	},
	methods:{
		
		//历史订单功能
		sethistoryOrderInfo(info){
			let personalityArr = []
			for(let k in info){
				this.params[k] = info[k];
				//处理特殊工艺 和 个性化服务
				/* specialprocess / personality
				review_file  shipment_report slice_report has_period
				blind impendance beveledge bankong via_in_pad
				*/
				//处理特殊工艺
				if(k == "blind" && info[k] > 0){
					this.specialprocess.push("blind");
					this.blind = 1
				}
				if(k=="impendance" && info[k] == 1){
					this.specialprocess.push("impendance");
				}
				if(k=="beveledge" && info[k] == 1){
					this.specialprocess.push("beveledge");
				}
				if(k=="bankong" && info[k] == 1 || k=="baobian" && info[k] == 1){
					this.specialprocess.push("bankong");
				}
				if(k=="via_in_pad" && info[k] == "Have"){
					this.specialprocess.push("via_in_pad");
				}
				//个性化服务
				// if(k == "review_file" && info[k] > 0){
				// 	this.personality.push("review_file");
				// 	this.isoldOdercout = true;
				// }
				if(k == "shipment_report" && info[k] > 0){					
					personalityArr.push("shipment_report");
				}
				if(k == "slice_report" && info[k] > 0){					
					personalityArr.push("slice_report");
				}
				if(k == 'film_report' && info[k] == 1){
					personalityArr.push('film_report')
				}
				// if(k == "has_period" && info[k] == 6){
				// 	this.personality.push("has_period");					
				// }

			}
			this.personality = personalityArr
			// if(this.params.has_period == 2) {
			// 	this.params.period_format = 0
			// }
		},
		orderSelected(v){
			let vm = this;
			vm.$http.post(vm.$api.historyOrderInfo,{pcb_order_sn:v.real}).then(function(res){
				if(res && res.code == 200 && res.data && res.data.info){
					let info = res.data.info;
					if(info.bheight) info.bheight = info.bheight + '';	
					if(info.copper) info.copper = Number(info.copper);	
					if(info.lineweight) info.lineweight = Number(info.lineweight);					
					vm.sethistoryOrderInfo(info);
				}else{
					vm.$alert.msg(res.msg)
				}
			})
		},
		setSelectItems(list){
			let tmp = [];
			if(list && list.length){
				let len = list.length;
				for(let i = 0; i<len ;i++){
					tmp.push({word:list[i],real:list[i]})
				}
			}
			return tmp;
		},
		searchOrder(opts){	
			let vm = this;
			
			vm.$http.post(vm.$api.historyOrderList,{pcb_order_sn:opts.keywords}).then((res)=>{
				if(res.code == 200 && res.data && res.data.order_sn_list){				
					opts.callBack(vm.setSelectItems(res.data.order_sn_list));					
				}else if(res.code==1001){
					//未登录
					if(!opts.first) vm.loginWinShow = true;
				}else{
					vm.$alert.msg(res.msg)
				}
			})
		},
		//历史订单功能	end
		//设置属性
		countTg(){
			let blayer = this.params.blayer,
				board_tg = this.params.board_tg,
				dft = "TG130",items;
			this.setAttr(this.list.board_tg,{value: true, key: 'show'});
			if (!this.isRogers) {
				items = ['TG140', 'TG180']
				if(blayer >= 4 && blayer < 6){
					// items = ["TG170"];
					dft = "TG130";
				}else if(blayer >=6 && blayer <=8) {
					// items = ["TG130"];
					dft = "TG150";
				}else if(blayer >=10){
					// items = ["TG130","TG150"];
					dft = "TG170";
				}
			} else {
				dft = 'TG130'
			}
			
			console.log('count tg---', this.isClick.board_tg, this.list.board_tg, items)
			if (!this.isClick.board_tg) {
				this.params.board_tg = dft
			}
			if(items){
				this.setAttr(this.list.board_tg,{value: false, key: 'show',items});
				if(this.$tools.inArray(board_tg,items)){
					this.params.board_tg = dft;
				}
			}
		},
		countLayer(){
			let plate_type = this.params.plate_type, dft = 2,
				blayer = this.params.blayer;
			this.list.blayer = this.$options.data().list.blayer
			this.setAttr(this.list.blayer,{value: true, key: 'show'});	
			if(plate_type === "Aluminum"){
				let items = [4,6,8,10,12,14,16,18,20,22];
				this.setAttr(this.list.blayer,{
					key:"show",
					value: false,
					items
				});
				//设置值
				dft = 1
				// !this.isChangeParams && (this.params.blayer = 1);
				// if(this.$tools.inArray(blayer,items)){
				// 	this.params.blayer = 1;
				// }
			} else if (plate_type === "Copper") {
				let items = [2,4,6,8,10,12,14,16,18,20,22];
				this.setAttr(this.list.blayer,{
					key:"show",
					value: false,
					items
				});
				//设置值
				dft = 1
				// this.params.blayer = 1;
			} else if (this.isFpc) {
				this.list.blayer = this.list.fpcLayer
				//设置值
				dft = 2
				// !this.isChangeParams && (this.params.blayer = 2);
			} else if (this.isRfpc) {
				this.list.blayer = this.list.rfpcLayer
				dft =4
				// if (!this.isChangeParams) {
				// 	this.params.blayer = 4
				// 	this.params.fpc_blayer = 2
				// }
				if(!this.isClick.fpc_blayer) {
					this.params.fpc_blayer = 2
				}
			} else if (this.isRogers) {
				dft = 2
				this.list.blayer = this.list.rogersLayer
				// this.setAttr(this.list.blayer,{value: false, key: 'show', items: [1]});
			}
			else{
				// !this.isChangeParams && (this.params.blayer = 2)
				dft = 2
				this.setAttr(this.list.blayer,{value: false, key: 'show', items: [22]});
				// this.setAttr(this.list.blayer,{value: true, key: 'show'});
			}
			if (!this.isClick.blayer) {
				this.params.blayer = dft
			}

		},
		countBheight(){
			let plate_type = this.params.plate_type,
				blayer = Number(this.params.blayer),
				bheight = this.params.bheight,
				items,dft = '1.6';
				this.list.bheight = this.replaceList.bheight;
			const newFr4 = ['1.7','1.8','1.9','2.1','2.2','2.3','2.4','2.6','2.7','2.8','2.9']	

			this.setAttr(this.list.bheight,{value: false})
			this.setAttr(this.list.bheight,{value: true,key: 'show'});	
			if(this.isFr4){
				if ([1, 6, 8, 10].includes(blayer)) {
					items = ['0.4', '2.6', '2.7', '2.8', '2.9', '3', '3.2']
				} else if([2, 4, 12, 14].includes(blayer)) {
					items = ['0.4', '3.2']
				}
				if(items){
					this.setAttr(this.list.bheight,{value: true,reverse:false,items});
				}

				this.setAttr(this.list.bheight,{value: false, key:'show',items: ['0.4']});
				
			} else if(this.isAluminum) {
				items = ['0.4','0.6','2.5','3.2', ...newFr4];
				this.setAttr(this.list.bheight,{value: false, key:'show',items});
				// if(this.$tools.inArray(bheight,items)){
				// 	this.params.bheight = dft;
				// }
			} else if(this.isCopper) {
				items = ['0.4','0.6','1.2','2','3.2', ...newFr4];
				this.setAttr(this.list.bheight,{value: false, key:'show',items});
				// if(this.$tools.inArray(bheight,items)){
				// 	this.params.bheight = dft;
				// }
			} else if(this.isRfpc) {
				items = ['1.7', '1.8', '1.9', '2.1', '2.2', '2.3', '2.5', '2.6', '2.7', '2.9' ,'3']
				this.setAttr(this.list.bheight,{value: false, key:'show',items});
				console.log('countBheight***', items, this.list.bheight)
				// if(this.$tools.inArray(bheight,items)){
				// 	this.params.bheight = dft;
				// }
			} else if(this.isRogers) {
				if( blayer == 2) {
					this.list.bheight = this.replaceList.rogersbheight1
					dft = '0.508'
				} else {
					this.list.bheight = this.replaceList.rogersbheight2
					dft = '1.6'
				}
			}
			const isHas = this.list.bheight.some(item => item.real == bheight)
			console.log('count bheight', bheight, dft, !isHas, this.list.bheight)
		
			if(this.$tools.inArray(bheight,items) || !this.isClick.bheight || !isHas){
				this.params.bheight = dft;
			}
		},
		countMaskColor() {
			let items,dft = 'Green',color = this.params.color
			this.list.color = this.$options.data().list.color
			this.setAttr(this.list.color,{ value: true, key: 'show'});
			if(this.isFr4) {
				items = ['HR White', 'Purple', 'Matte Green', 'Clear']
				dft = 'Green'
			} else if(this.isAluminum || this.isCopper) {
				items = ['Red', 'Yellow', 'Blue', 'Purple', 'Matte Green', 'Clear']
				dft = 'White'
			} else if(this.isRfpc) {
				items = ['HR White']
				dft = 'Green'
			} else if(this.isRogers) {
				this.list.color = this.list.rogerscolor
			}
			console.log('countMaskColor--',!this.isClick.color, this.list.color)
			if(this.$tools.inArray(color,items) || !this.isClick.color){
				this.params.color = dft
			}
			if(items) {
				this.setAttr(this.list.color,{ value: false, key: 'show',items});
			}
		},
		countCharcolor(){
			let color =  this.params.color,items;
			let dft = 'White'
			this.setAttr(this.list.charcolor,{value: true,key:'show'});
			this.setAttr(this.list.charcolor,{value: false,reverse:false,items});
			if (!(this.isRfpc || this.isRogers)) {
			if(!["White", "HR White"].includes(color)){
				items = ["Black"];
				this.params.charcolor = "White";
			}else{
				items = ["White"];
				this.params.charcolor = "Black";
			}
			this.setAttr(this.list.charcolor,{value: false,key:'show', items:['Clear']});
			}

			if (this.isRfpc || this.isRogers) {
				
				if (['Black', 'Matt Black'].includes(color)) {
					dft = 'White'
					items = ['Black']
				}

				if (['White'].includes(color)) {
					dft = 'Black'
					items = ['White']
				}
			}

			if(this.$tools.inArray(this.params.charcolor,items)){
				this.params.charcolor = dft
			}
			if (items) {
				this.setAttr(this.list.charcolor,{value: true,reverse:false,items});
			}
			
		},
		//外层铜厚
		countCopper(){
			let blayer = this.params.blayer,items,dft = 1;
			const copper = this.params.copper
			this.setAttr(this.list.copper,{value: true, key:'show'});
			this.setAttr(this.list.copper,{value: false})
			if (this.isFr4) {
				items = [0.5, 3, 4, 5 , 6]
				// this.setAttr(this.list.copper,{value: false, key:'show', items});
			} else if (this.isAluminum || this.isCopper) {
				dft = 0.5
				items = [1.5, 5, 6]
				// this.setAttr(this.list.copper,{value: false, key:'show', items});
				// this.params.copper = dft
			} else if (this.isRfpc || this.isRogers) {
				items = [0.5, 1.5]
				dft = 1
			} 

			this.setAttr(this.list.copper,{value: false, key:'show', items});
			if(this.$tools.inArray(copper, items) || !this.isClick.copper){
				this.params.copper = dft
			}
		},
		countInsidecopper(){
			let blayer = this.params.blayer,items,
				dft = 0;
			if(blayer>= 4){
				dft = 0.5 ;
			}
			this.setAttr(this.list.insidecopper,{value: true, key:'show'});
			this.setAttr(this.list.insidecopper,{value: false})
			if( blayer > 2) {
				if (!(this.isRfpc || this.isRogers)) {
					items = [3, 4, 5, 6]
					dft = 0.5
				} else{
					items = [0.5]
					dft = 1 
				}
			}
			if((this.manualParams.insidecopper === undefined && !this.isClick.insidecopper) || this.$tools.inArray(this.params.insidecopper, items)){
				this.params.insidecopper = dft;
			}
			if(items) {
				this.setAttr(this.list.insidecopper,{value: false, key:'show', items});
			}


		},
		insidecopperChange(e){
			this.manualParams.insidecopper = e.value;
		},
		countLineweight(){

			const { blayer, blind, lineweight, copper } = this.params	
			let	items,dft = 6;
			this.setAttr(this.list.lineweight,{value: true, key:'show'})
			this.setAttr(this.list.lineweight,{value: false})
			const fpc= [2,3]

			if (this.isFr4) {
				if(blayer == 1){
					items = [3.5,4];
				}else if(blayer == 2){
					items = [3.5];
				}
	
				if(blayer < 3 && copper == 2){
					items = [3.5, 4, 5]
				}
				this.setAttr(this.list.lineweight,{value: false, key:'show', items:fpc})
				if(this.$tools.inArray(lineweight,fpc)){
					this.params.lineweight = dft;
				}
				// if(items){
				// 	this.setAttr(this.list.lineweight,{value: true,reverse:false,items});
				// 	if(this.$tools.inArray(lineweight,items)){
				// 		this.params.lineweight = dft;
				// 	}
				// }else{
				// 	this.setAttr(this.list.lineweight,{value: false});
				// }
				if(blind > 0){
					this.setAttr(this.list.lineweight,{value: false});
				}
			} else if(this.isAluminum || this.isCopper) {
				// 铝/铜 基板
				items = [2,3,3.5]
				if(this.$tools.inArray(lineweight,items)){
					this.params.lineweight = dft;
				}
				this.setAttr(this.list.lineweight,{value: false, key:'show', items})
			} else if(this.isFpc) {
				// fpc软板
				items = [10,8,3.5]
				if(this.$tools.inArray(lineweight,items)){
					this.params.lineweight = dft;
				}
				this.setAttr(this.list.lineweight,{value: false, key:'show', items})
			} else if(this.isRfpc || this.isRogers) {
				items = [2]
				if(this.$tools.inArray(lineweight,items)){
					this.params.lineweight = dft;
				}
				this.setAttr(this.list.lineweight,{value: false, key:'show', items})
			}
			
		},
		countVias(){
			let bheight = this.params.bheight,
				blind = this.params.blind,
				blayer = this.params.blayer,
				vias =  this.params.vias,items,dft = 0.3;
			
			this.setAttr(this.list.vias,{value: true, key: 'show'})	
			this.setAttr(this.list.vias,{value: false})

			if (this.isFr4 || this.isFpc)	{
				items = [0.175,0.5, 1]
				this.setAttr(this.list.vias,{value: false, key: 'show', items})	
				if(this.$tools.inArray(vias,items)){
					this.params.vias = dft;
				}
				this.list.vias[2].word = '0.3mm↑'

				if (!this.isFpc) {
					dft  = 1
					if(blayer == 1){
						items = [0.25,0.2,0.15];
						//vias.setEdit([0.3],{type:1});
					}else if(blayer == 2){
						if(bheight > 1.2 || bheight < 0.6 ){
							items = [0.15]
						}
					}else{
						if(blayer >= 4)	{
							if(bheight == 2.0 || bheight == 2.5 || bheight == 3.0 || bheight == 3.2) {
								items = [0.15]
							}
						}
					}
				}

				// if(items){
				// 	this.setAttr(this.list.vias,{value: true,reverse:false,items});
				// 	if(this.$tools.inArray(vias,items)){
				// 		this.params.vias = dft;
				// 	}
				// }else{
				// 	this.setAttr(this.list.vias,{value: false});
				// }
				// if(blind > 0){
				// 	//this.setAttr(this.list.vias,{value: false});
				// }
			} else if(this.isAluminum || this.isCopper) {
				this.list.vias[2].word = '0.3mm'
				items = [0.25, 0.2, 0.15, 0.175]
				this.setAttr(this.list.vias,{value: false, key: 'show', items})
			} else if(this.isRfpc) {
				this.list.vias[2].word = '0.3mm'
				items = [0.175]
				this.setAttr(this.list.vias,{value: false, key: 'show', items})
			} else {
				this.list.vias[2].word = '0.3mm'
			}
			
		},
		countPlugInHoles() {
			const { blayer, vias, plug_in_holes } = this.params
			let dft = 0, items
			this.setAttr(this.list.plug_in_holes,{value: false})
			if (this.notIsFr4) {
				if (blayer == 1 && vias < 1) {
					dft = 1
					items = [0]
				}

				if (items) {
					this.setAttr(this.list.plug_in_holes,{value: true, items})
					if (this.$tools.inArray(plug_in_holes, items)) {
						this.params.plug_in_holes = dft
					}
				}
			} else {
				this.params.plug_in_holes = 0
			}
			
		},
		countSpray(){
			let bankong = this.params.bankong,
				plate_type = this.params.plate_type,
				spray = this.params.spray,items,dft = 'HASL';
				// console.log(bankong)
			this.setAttr(this.list.spray,{value: true, key: 'show'})	
			this.setAttr(this.list.spray,{value: false,reverse:false});
			if (this.isFr4 || this.isAluminum)	{
				// fr-4、铝基板
				if(bankong === 1 && this.isFr4){
					// items = ['OSP'];
					this.setAttr(this.list.spray,{value: true,reverse:false,items: ['OSP']});
					if(this.$tools.inArray(spray,['OSP'])){
						this.params.spray = dft;
					}
				}
				
				items = ['Electroplated Gold', 'Immersion Silver', 'Immersion Tin', 'ENIG + OSP','Gold Finger Plating']
				
				// this.setAttr(this.list.spray,{value: true,reverse:false,items});
				this.setAttr(this.list.spray,{value: false, key: 'show', items})	
				if(this.$tools.inArray(spray,items)){
					this.params.spray = dft;
				}
				
			} else if (this.isCopper) {
				// 铜基板
				items =['HASL', 'Lead free HASL','Electroplated Gold', 'Immersion Silver', 'Immersion Tin', 'ENIG + OSP', 'Gold Finger Plating']
				dft = 'OSP'

				this.setAttr(this.list.spray,{value: false, key: 'show', items})	
				if(this.$tools.inArray(spray,items)){
					this.params.spray = dft;
				}
			} else if (this.isFpc) {
				// 软板
				items =['HASL', 'Lead free HASL', 'Immersion Silver', 'Immersion Tin', 'ENIG + OSP', 'Gold Finger Plating']
				dft = 'ENIG'
				this.setAttr(this.list.spray,{value: false, key: 'show', items})	
				if(this.$tools.inArray(spray,items)){
					this.params.spray = dft;
				}
			} else if (this.isRfpc) {
				// 软硬结合板
				items =['HASL', 'Lead free HASL', 'Electroplated Gold', 'Immersion Tin', 'ENIG + OSP', 'Gold Finger Plating' ]
				dft = 'ENIG'
				this.setAttr(this.list.spray,{value: false, key: 'show', items})	
				if(this.$tools.inArray(spray,items)){
					this.params.spray = dft;
				}
			} else if(this.isRogers) {
				this.params.spray = 'Lead free HASL'
			}
			
		},
		countCjh(){
			let spray = this.params.spray;
			if(spray !== 'ENIG'){
				this.params.cjh = "1";
			}
		},
		countTest() {
			let blayer = this.params.blayer,
				area = this.area ||0,
				test = this.params.test,
				testpointSum = this.testpointSum || 0,
				items,dft="Sample Test Free"
				// Fr-4
			this.setAttr(this.list.test,{value: false,items:['Batch Flying Probe Test']})
			if(!this.notIsFr4) {
				if(blayer == 1) {
					items = ['Sample Test Free','Batch Flying Probe Test','Batch Fixture Test'];
					dft = 'Visual Inspection';
				} else {
					if(area <= 0.5) {
						items = ['Batch Flying Probe Test','Batch Fixture Test','Visual Inspection'];
					}
					
					if (area > 0.5 && area < 5) {
						items = ['Sample Test Free', 'Visual Inspection']
						dft = 'Batch Flying Probe Test'
					}

					if (area >= 5) {
						if (testpointSum < 60 * 10000) {
							items = ['Sample Test Free', 'Visual Inspection']
							dft = 'Batch Fixture Test'
						}

						if (testpointSum >= 60 * 10000) {
							items = ['Sample Test Free', 'Visual Inspection']
							dft = 'Batch Fixture Test'
							this.setAttr(this.list.test,{value: true,items:['Batch Flying Probe Test']})
						}
					}

				}
			} else {
				if (area < 5) {
					items = ['Sample Test Free', 'Visual Inspection']
					dft = 'Batch Flying Probe Test'
				}

				if (area >= 5) {
					if (testpointSum < 60 * 10000) {
						items = ['Sample Test Free', 'Visual Inspection']
						dft = 'Batch Fixture Test'
					}

					if (testpointSum >= 60 * 10000) {
						items = ['Sample Test Free', 'Visual Inspection']
						dft = 'Batch Fixture Test'
						this.setAttr(this.list.test,{value: true,items:['Batch Flying Probe Test']})
					}
				}
			}
			
			if(items){
				this.setAttr(this.list.test,{value: false,key:'show',reverse:true,items})
				if (!this.isClick.board_tg || this.$tools.inArray(test,items)) {
					this.params.test = dft
				}
			}
		},
		countBankong(){
			//spray = this.params.spray,
			let copper = this.params.copper,
				plate_type = this.params.plate_type;
			if(plate_type == 'Fr-4' && (copper>= 0.5 && copper <= 4)){
				this.setAttr(this.list.specialprocess,{value:false,items:['bankong']});
			}else{
				this.setAttr(this.list.specialprocess,{value:true,items:['bankong']});
				this.$tools.inArray('bankong',this.specialprocess,false,'del');
			}
			if( this.isAluminum || this.isCopper || this.isFpc) {
			this.params.bankong = ''
			}
		},
		countVia_in_pad(){
			let copper = this.params.copper,
				plate_type = this.params.plate_type;
			if(plate_type == 'Fr-4' && (copper>= 0.5 && copper <= 4)){
				this.setAttr(this.list.specialprocess,{value:false,items:['via_in_pad']});				
			}else{
				this.setAttr(this.list.specialprocess,{value:true,items:['via_in_pad']});				
				this.$tools.inArray('via_in_pad',this.specialprocess,false,'del');				
			}
		},
		countBlind(){
			//HDI 阶数
			let blayer = this.params.blayer,
				plate_type = this.params.plate_type;
				if(blayer > 2 && (this.isFr4 || this.isRfpc || this.isRogers)){
					this.setAttr(this.list.specialprocess,{value:false,items:['blind']});		
					this.hasBlindShow = true
				}else{
					this.setAttr(this.list.specialprocess,{value:true,items:['blind']});
					this.$tools.inArray('blind',this.specialprocess,false,'del');
					this.hasBlindShow = false
					this.blind = 0
				}
		},
		countBeveledge(){
			//金手指规则
			let copper = this.params.copper,
				plate_type = this.params.plate_type;
			if(plate_type == 'Fr-4' && (copper>= 0.5 && copper <= 4)){
				this.setAttr(this.list.specialprocess,{value:false,items:['beveledge']});
			}else{
				this.setAttr(this.list.specialprocess,{value:true,items:['beveledge']});
				this.$tools.inArray('beveledge',this.specialprocess,false,'del');
			}
		},
		countSpecialprocess(v){
			if(this.$tools.inArray('blind',v)){
				//HDI
				if(!this.params.blind) this.params.blind = 1;
			}else{
				this.params.blind = '';
			}
			//盘中孔
			if(this.$tools.inArray('via_in_pad',v)){
				//HDI
				this.params.via_in_pad = 'Have';
			}else{
				this.params.via_in_pad = 'N/A';
			}
			//impendance  需要计算 countimpendance
			if(this.$tools.inArray('impendance',v)){
				//HDI
				this.params.impendance = 1;
			}else{
				this.params.impendance = 0;
			}
			//bankong  需要计算 countbankong
			if(this.$tools.inArray('bankong',v)){
				//HDI
				this.params.bankong = 1;
				this.params.baobian = 1;
			}else{
				this.params.bankong = 0;
				this.params.baobian = 0;
			}
			//以下参数没有其他操作
			if(this.$tools.inArray('beveledge',v)){
				this.params.beveledge = 1;
			}else{
				this.params.beveledge = 0;
			}
		},
		countPersonality(v){
			//出货报告
			let hasReport = 0,vm = this;
			if(this.$tools.inArray('shipment_report',v)){
				hasReport ++;
				this.params.shipment_report = 1;
				if(!this.params.report_type){
					this.params.report_type = 2
				}
			}else{
				this.params.shipment_report = 0;
			}
			//切片报告
			if(this.$tools.inArray('slice_report',v)){
				hasReport ++;
				if(!this.params.report_type){
					this.params.report_type = 2
				}
				this.params.slice_report = 1;
			}else{
				this.params.slice_report = 0;
			}
			// 实物菲林
			if(this.$tools.inArray('film_report',v)){
				hasReport ++;
				if(!this.params.report_type){
					this.params.report_type = 2
				}
				this.params.film_report = 1;
			}else{
				this.params.film_report = 0;
			}
			if(!hasReport && !this.params.film_report && !this.params.slice_report && !this.params.shipment_report){
				this.isClick.report && (this.params.report_type = 0)
				if(!this.notCheckReport.length) {
					this.notCheckReport.push('not_required')
				}
			} else {
				this.notCheckReport = []
			}

			//ul mark
			if(this.$tools.inArray('has_period',v)){
				this.params.has_period = 6;
			}else{
				//加入购物车没有选需要二次提示
				this.params.has_period = 2;
			}
		},
		countPersonalityNew() {
			let items
			// this.personality = []
			this.setAttr(this.list.personality, { value: true, key: 'show' })
			if (this.notIsFr4){
				items = ['film_report']
			}
			if (items) {
				this.setAttr(this.list.personality, { value: false, key: 'show', items })
			}
		},
		// 设置拼板中的单板是否禁用 解析是多板的，禁选单板
		countBoardType(){
			let items
			if(this.resolvedFileData.oneOrMoreBoard == '多板'){
				items = [1];
			}
			if(items){
				this.setAttr(this.list.unitsItem,{value: true, reverse: false, items});
			}
		},
		// 设置拼板中的单板是否禁用
		countBoardTypeByPbnum(){
			if(this.resolvedFileData.oneOrMoreBoard == '多板'){
				return false
			}
			let items
			let disable = true
			if(this.params.pbnum > 1){
				items = [1]
				this.params.units = 3
			}
			else{
				items = []
				disable = false
			}
			if(items){
				this.setAttr(this.list.unitsItem,{value: disable, reverse:false, items});
			}
		},
		// 处理HDI特殊参数
		handleBlindChange(v){
			if(this.blind){
				if(!this.params.blind){
					this.params.blind = 1
				}
			}
			else {
				this.params.blind = ''
			}
		},
		/* *****fpc相关****** */
		//FPC板厚
		countFpcThickness(){
			let items,dft = 0.2;
			const { blayer, fpc_thickness, fpc_blayer } = this.params
			this.setAttr(this.fpcList.fpc_thickness,{value: false})
			const layer = this.isFpc ? blayer : fpc_blayer
			if (layer == 1) {
				dft = 0.1
				items = [0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45]
			} else if (layer == 2) {
				dft = 0.2
				items = [0.3, 0.35, 0.4, 0.45]
			} else if(layer == 3) {
				dft = 0.3
				items = [0.1,0.13, 0.4, 0.45]
			} else if(layer == 4) {
				dft = 0.3
				items = [0.1,0.13, 0.15, 0.4, 0.45]
			} else {
				dft = 0.3
				items = [0.1,0.13, 0.15, 0.2, 0.25]
			}

			this.setAttr(this.fpcList.fpc_thickness, {value: true, items} )

			if(this.$tools.inArray(fpc_thickness, items) || !this.isClick.fpc_thickness){
				this.params.fpc_thickness = dft
			}
		},
		//FPC颜色
		countFpcColor(){
			let items,dft = 'Yellow';
			const { fpc_cover,fpc_color } = this.params
			this.setAttr(this.fpcList.fpc_color,{value: true,  key:'show'})
			if (fpc_cover.includes('Coverlay')) {
				items = [ 'Green', 'Red', 'Orange', 'Silver' ]
			} else {
				items = [ 'White' ]
			}
			this.setAttr(this.fpcList.fpc_color,{value: false,  key:'show', items})

			if(this.$tools.inArray(fpc_color, items)){
				this.params.fpc_color = dft
			}
		},
		//FPC字符颜色
		countFpcCharcolor(){
			let items,dft = 'White';
			const { fpc_color,fpc_charcolor } = this.params
			this.setAttr(this.fpcList.fpc_charcolor,{value: false})
			if (fpc_color == 'White') {
				items = ['White']
				dft = 'Black'
			}

			if (fpc_color == 'Black') {
				items = ['Black']
				dft = 'White'
			}

			items && this.setAttr(this.fpcList.fpc_charcolor,{value: true, items})

			if(this.$tools.inArray(fpc_charcolor, items)){
				this.params.fpc_charcolor = dft
			}
		},
		// fpc补强
		countFpcStiffener() {
			const fieldList = ['reinforce_steel', 'reinforce_aluminium', 'reinforce_fr4', 'reinforce_pi']
			const valueMap = {
				reinforce_steel: { key: 'steel_thickness', value: '0.1'} ,
				reinforce_aluminium: { key: 'aluminium_thickness', value: '0.3'},
				reinforce_fr4: { key: 'fr4_thickness', value: '0.1'},
				reinforce_pi: { key: 'pi_thickness', value: '0.1'}
			}
			fieldList.forEach(field => {
				this.params[field] = 0
			})

			this.fpc_stiffener.forEach(field => {
				if (fieldList.includes(field)) {
					this.params[field] = 1
					console.log(valueMap[field])
					const { key, value } = valueMap[field]
					if(!this.params[key]) {
						this.params[key] = value
					}
					console.log(this.params[key])
				}
			})
				
		}
	},
	watch:{		
		relation(){
			//改变高度
			setTimeout(()=>{
				this.setulmarkHeight();
			});
		}
	}
}